import * as yup from 'yup';
import { MessageConstant } from '../MessageConstant';

const message = MessageConstant.common;

export const adjustmentValidation: { [x: string]: any; } = {
  adjustmentType: yup.string().required(message.MISSING),
};
export const updateAdjustmentValidation: { [x: string]: any; } = {
  ...adjustmentValidation,
};

export const updateAdjustmentValidationSchema = yup.object().shape(updateAdjustmentValidation);

